"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreditResponseModalCms = void 0;
var CreditResponseModalCms = /** @class */ (function () {
    function CreditResponseModalCms() {
        this.newServiceRequirementTitleLabel = 'Before we can continue...';
        this.removeCartLabel = 'Remove from cart';
        this.unpaidBalanceLabel = 'Unpaid balance found';
        this.thankYouLabel = 'Thank you';
        this.attentionTitleLabel = 'Attention';
        this.creditHistoryConsentLabel = 'Based on your credit history, we will impose certain conditions or restrictions on your' +
            ' new service request as shown below.';
        this.creditHistoryChangesConsentLabel = 'Based on your credit history, we need to make some changes' +
            ' to your order. Please review your options before you submit your order.';
        this.outstandingBalanceAlertLabel = 'Our records show that you still have an outstanding balance. ' +
            'It must be paid in full before you can place this order.';
        this.paymentProcessingErrTxt = 'Sorry, but we\'re unable to process your payment at this time.';
        this.termsConditionsLabel = 'Terms Conditions Msg';
        this.termsConditionsConsentChkBoxLabel = 'I authorize AT&T to charge the one-time payment <br>' +
            'to my debit/credit card, or I authorize <br>' +
            'my bank to deduct the one-time payment from <br>' +
            'my checking/savings account, for the required <br>' +
            'amount due today. <br>' +
            'If AT&T is unable to secure funds from my <br>' +
            'debit/credit card or my bank for any reason, <br>' +
            'including, but not limited to, insufficient funds in <br>' +
            'my debit/credit card or bank account or <br>' +
            'insufficient or inaccurate information provided <br>' +
            'by me when submitting my electronic payment, <br>' +
            'AT&T may undertake further collection action,<br>' +
            'including application of fees to the extent <br>' +
            'permitted by law. <br>' +
            'AT&T will send me an email confirmation of my <br>' +
            'one-time payment. <br>';
        this.removeContinueCTALabel = 'Remove & Continue';
        this.termsConditionsLinkLabelOne = 'One-time Payment <br>' +
            'Terms & Conditions <br>';
        this.continueRemoveCTALabel = 'Remove and continue';
        this.continueCTALabel = 'Continue';
        this.cancelCTALabel = 'Cancel';
        this.submitCTALabel = 'Submit payment & continue';
        this.debtUICollectStatusLabel = 'OK';
        this.emptyTxtLabel = '';
        this.edspRemoveDevicesMessage = "We've removed your device(s) from your order.";
        this.odaUnApprovedCreditErrTitle = "We're unable to complete your order";
        this.odaUnApprovedCreditErrDescription = "Looks like you\u2019ve reached the maximum number of lines you\u2019re allowed to have on your account.";
    }
    return CreditResponseModalCms;
}());
exports.CreditResponseModalCms = CreditResponseModalCms;
//# sourceMappingURL=CreditResponseModal.cms.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/checkout-ui/components/cards/CreditResponseModal/CreditResponseModal.cms.js
// module id = 2012
// module chunks = 8